(function () {
   'use strict';

   var VPJw = require('./videoplayer_jw.js');
   var VPYoutube = require('./videoplayer_youtube.js');
   var VPSmartMovie = require('./videoplayer_smartmovie.js');
   var acHelper = require('../AssetCore/helper.js');
   var ACVideo = require('../AssetCore/mediaVideo.js');
   var logger = new (require('../helpers/logger.js'))("VideoPlayer Helper").setColor("#82cc60").setDebug(true);

   var helper = require('../helpers/generic.js');

   module.exports = {
     fromMediaOrUrl: fromMediaOrUrl,
     fromSmartmovieUrl: fromSmartmovieUrl
  };

  function fromMediaOrUrl(acMediaOrUrl, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
    if (inline && helper.undefOrNull(container)){
      throw "You must supply a container if you want to play the video inline!";
    }
    if (helper.undefOrNull(acMediaOrUrl)){
      throw "Could not instantiate VideoPlayer. Data was " + acMediaOrUrl;
    }

    if (helper.undefOrNull(acMediaOrUrl.type)){
      if (typeof acMediaOrUrl == "string" && acMediaOrUrl.includes("/")){ //is not an url
        return fromClipUrl(acMediaOrUrl, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
      } else {
        throw "Only ACMedia or URLs are allowed for acMediaOrUrl; The current String is no url: " + acMediaOrUrl;
      }
    } else {
      return fromMedia(acMediaOrUrl, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
    }
  }

  // generated Media data to be used for constructing ACMedia for cases where no assetcore code is available
  function generateAcVideo(type, quality, provider, url){
    var acm = acHelper.generateMediaData(type, quality, provider, url);
    return new ACVideo(acm);
  }

  function fromClipUrl(url, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
    var acMedia = generateAcVideo("video", defaultQuality, "url", url);
    return fromMedia(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
  }

  function fromSmartmovieUrl(smartmovieUrl, $element, posterMediaImage, defaultQuality, optionsOverride, playButtonImage, playButtonHoverImage){
    var acMedia = generateAcVideo("smartmovie", defaultQuality, "url", smartmovieUrl);
    return new VPSmartMovie(acMedia, false, $element, posterMediaImage, defaultQuality, optionsOverride, playButtonImage, playButtonHoverImage);
  }

  function fromMedia(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
    if (acMedia.type() == "video" && acMedia.provider() != "youtube"){
      return new VPJw(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
    } else if (acMedia.provider() == "youtube"){
      return new VPYoutube(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
    } else if (acMedia.type() == "smartmovie"){
      return new VPSmartMovie(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
    } else {
      throw "unsupported video type: '"+acMedia.type()+"'/'"+acMedia.provider()+"'";
    }
  }

}());



//////////////////
// WEBPACK FOOTER
// ./src/VideoPlayer/helper.js
// module id = 27
// module chunks = 0